
import { Avatar, Grid, List, ListItem, Typography, useTheme } from '@mui/material'
import React from 'react'
import { createPlaceholderNote, createPlaceholderUser } from './placeholderData'

interface PlaceholderCommentProps {
  expanded: boolean | false
}

const PlaceholderComment: React.FC<PlaceholderCommentProps> = ({ expanded }) => {
  const theme = useTheme()
  const placeholderUser = createPlaceholderUser(theme)
  const _placeholderNote = createPlaceholderNote(theme)
  const noteOwner = placeholderUser

  return (
    <List
      sx={{
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        // bgcolor: theme.palette.background.default,
        bgcolor: 'transparent',
        '--color': theme.palette.text.link,
        borderRadius: '10px',
        overflowY: 'auto',
        maxHeight: !expanded ? 'calc(100vh - 300px)' : 'calc(100vh - 410px)',
        p: 2,
        transition: 'all 0.3s ease',
      }}
    >
      <Grid container alignItems='center'>
        {/* Owner Avatar */}

        <ListItem
          key={'placeholder-comment'}
          sx={{
            mb: 2,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            bgcolor: theme.palette.background.mentions,
            '--color': theme.palette.text.link,
            borderRadius: '10px',
            p: 1,
            border: `1px solid ${theme.palette.text.primary}`,
            gap: 3,
          }}
        >
          <Grid item>
            {noteOwner && (
              <Avatar
                alt={(noteOwner as any).name}
                src={noteOwner.image_512 || (noteOwner as any).imageUrl}
                sx={{ width: 48, height: 48 }}
              />
            )}
          </Grid>
          <Grid item xs>
            <Typography sx={{ color: theme.palette.text.secondary }}>No Comments</Typography>
          </Grid>
        </ListItem>
      </Grid>
    </List>
  )
}

export default PlaceholderComment
